(function () {
  const overlay = document.getElementById('quick-view-modal');
  const content = document.getElementById('qv-content');
  const closeBtn = document.getElementById('qv-close-btn');
  if (!overlay) return;

  document.addEventListener('click', async function (e) {
    const trigger = e.target.closest('.qv-trigger');
    if (!trigger) return;
    e.preventDefault(); e.stopPropagation();

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    content.innerHTML = '<div class="qv-spinner"><svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="60" stroke-dashoffset="20"/></svg></div>';

    try {
      // Timeout 6s : si le fetch (page produit complète) traîne sur mobile,
      // on n'immobilise pas l'utilisateur sur un spinner mort.
      const ctrl = new AbortController();
      const to = setTimeout(() => ctrl.abort(), 6000);
      let html;
      try {
        const res = await fetch(trigger.dataset.productUrl + '?view=quick-view', { signal: ctrl.signal });
        html = await res.text();
      } finally { clearTimeout(to); }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const wrap = doc.querySelector('.qvp');
      if (!wrap) { location.href = trigger.dataset.productUrl; return; }

      content.innerHTML = wrap.outerHTML;

      // Réexécuter scripts
      content.querySelectorAll('script').forEach(old => {
        const s = document.createElement('script');
        [...old.attributes].forEach(a => s.setAttribute(a.name, a.value));
        s.textContent = old.textContent;
        old.replaceWith(s);
      });

      // Carousel rebind
      setTimeout(() => {
        const slider = content.querySelector('#qvp-slider');
        if (!slider) return;
        const slides = content.querySelectorAll('.qvp__slide');
        const dots   = content.querySelectorAll('.qvp__dot');
        const prev   = content.querySelector('#qvp-prev');
        const next   = content.querySelector('#qvp-next');
        const closeMob = content.querySelector('#qvp-close-mob');
        if (closeMob) closeMob.onclick = () => closeModal();

        if (!slides.length) return;
        let cur = 0;

        function goTo(n) {
          slides[cur].classList.remove('is-active');
          if (dots[cur]) dots[cur].classList.remove('is-active');
          cur = ((n % slides.length) + slides.length) % slides.length;
          slides[cur].classList.add('is-active');
          if (dots[cur]) dots[cur].classList.add('is-active');
        }

        if (prev) prev.onclick = (e) => { e.stopPropagation(); goTo(cur - 1); };
        if (next) next.onclick = (e) => { e.stopPropagation(); goTo(cur + 1); };
        dots.forEach(d => d.onclick = () => goTo(parseInt(d.dataset.i)));

        let sx = 0;
        slider.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
        slider.addEventListener('touchend', e => {
          const dx = sx - e.changedTouches[0].clientX;
          if (Math.abs(dx) > 40) goTo(dx > 0 ? cur + 1 : cur - 1);
        });
      }, 50);

      // Prix dynamiques
      content.querySelectorAll('variant-radios input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => {
          const el = input.closest('variant-radios');
          const variants = JSON.parse(el.querySelector('script[type="application/json"]')?.textContent || '[]');
          const selected = [...el.querySelectorAll('[name]')].reduce((acc, inp) => {
            if (inp.checked || inp.type !== 'radio') acc[inp.name] = inp.value;
            return acc;
          }, {});
          const match = variants.find(v =>
            v.options.every((opt, i) => opt === Object.values(selected)[i])
          );
          if (match) {
            const hiddenId = content.querySelector('input[name="id"]');
            if (hiddenId) hiddenId.value = match.id;
            const priceEl = content.querySelector('.price-item--regular, .price-item--sale');
            if (priceEl) priceEl.textContent = (match.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
          }
        });
      });

            // Ajout au panier AJAX
        content.addEventListener('submit', async function(e) {
        const form = e.target.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;
        e.preventDefault();

        const btn = form.querySelector('.qvp__atc');
        const originalText = btn?.textContent;
        if (btn) { btn.disabled = true; btn.textContent = '…'; }

        try {
            const formData = new FormData(form);
            const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
            });

            if (res.ok) {
            // Message succès
            let msgEl = content.querySelector('.qvp__cart-msg');
            if (!msgEl) {
                msgEl = document.createElement('div');
                msgEl.className = 'qvp__cart-msg';
                const bottom = content.querySelector('.qvp__bottom');
                if (bottom) bottom.insertAdjacentElement('afterend', msgEl);
            }
            msgEl.innerHTML = `
                <span class="qvp__cart-msg-text">✓ Ajouté au panier</span>
                <a href="/cart" class="qvp__cart-link">Voir le panier →</a>
            `;
            msgEl.classList.add('is-visible');

            // Compteur panier
            const cart = await fetch('/cart.js').then(r => r.json());
            const bubble = document.querySelector('.cart-count-bubble');
            const sh = bubble?.querySelector('span[aria-hidden]');
            const ss = bubble?.querySelector('span:not([aria-hidden])');
            if (sh) sh.textContent = cart.item_count;
            if (ss) ss.textContent = cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');
            if (bubble && cart.item_count > 0) bubble.classList.remove('hidden');

            if (btn) { btn.disabled = false; btn.textContent = originalText; }

            // Masquer message après 4s
            setTimeout(() => msgEl.classList.remove('is-visible'), 4000);
            } else {
            if (btn) { btn.disabled = false; btn.textContent = originalText; }
            }
        } catch {
            if (btn) { btn.disabled = false; btn.textContent = originalText; }
        }
        }, true);


    } catch {
      // Lenteur/abandon du fetch : au lieu d'un cul-de-sac, on envoie
      // l'utilisateur sur la vraie fiche produit (jamais de vente perdue).
      location.href = trigger.dataset.productUrl;
    }
  });

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
})();
